import React from 'react';
import { HomeIcon, ClipboardCheckIcon, UsersIcon } from 'lucide-react';
type Screen = 'home' | 'checkin' | 'partner';
interface BottomNavProps {
  activeTab: Screen;
  onNavigate: (screen: Screen) => void;
}
export function BottomNav({
  activeTab,
  onNavigate
}: BottomNavProps) {
  return <nav className="fixed bottom-0 left-0 right-0 bg-background border-t border-border safe-bottom z-50" role="navigation" aria-label="Main navigation" data-id="element-9">
      <div className="max-w-md mx-auto flex items-center justify-around px-4 py-2" data-id="element-10">
        <button onClick={() => onNavigate('home')} className={`flex flex-col items-center justify-center gap-1 py-2 px-4 min-h-[48px] min-w-[64px] rounded-lg transition-colors ${activeTab === 'home' ? 'text-primary' : 'text-muted-foreground hover:text-foreground'}`} aria-label="Home" aria-current={activeTab === 'home' ? 'page' : undefined} data-id="element-11">
          <HomeIcon className="w-6 h-6" data-id="element-12" />
          <span className="text-xs font-medium" data-id="element-13">Home</span>
        </button>

        <button onClick={() => onNavigate('checkin')} className={`flex flex-col items-center justify-center gap-1 py-2 px-4 min-h-[48px] min-w-[64px] rounded-lg transition-colors ${activeTab === 'checkin' ? 'text-primary' : 'text-muted-foreground hover:text-foreground'}`} aria-label="Check-in" aria-current={activeTab === 'checkin' ? 'page' : undefined} data-id="element-14">
          <ClipboardCheckIcon className="w-6 h-6" data-id="element-15" />
          <span className="text-xs font-medium" data-id="element-16">Check-in</span>
        </button>

        <button onClick={() => onNavigate('partner')} className={`flex flex-col items-center justify-center gap-1 py-2 px-4 min-h-[48px] min-w-[64px] rounded-lg transition-colors ${activeTab === 'partner' ? 'text-primary' : 'text-muted-foreground hover:text-foreground'}`} aria-label="Partner" aria-current={activeTab === 'partner' ? 'page' : undefined} data-id="element-17">
          <UsersIcon className="w-6 h-6" data-id="element-18" />
          <span className="text-xs font-medium" data-id="element-19">Partner</span>
        </button>
      </div>
    </nav>;
}